export default __webpack_public_path__ + "static/media/dragon.fa4e1d42.png";